import { PageHeader, CtaBand } from "../components/site/Sections";
import { Reveal } from "../components/site/Reveal";
import { CaseCard } from "../components/site/CaseCard";
import { Seo } from "../components/site/Seo";
import { useCases } from "../lib/useCases";

export default function Work() {
  const { cases } = useCases();
  return (
    <>
      <Seo path="/work" title="Our work & case studies" description="See how The Catalyst helps Canberra businesses grow, with the challenge, approach and results for each project." />
      <PageHeader eyebrow="Work" lines={["Results you", "can measure."]}
        intro="Before and after, minus the dramatic music. [Sample projects — replace with your real case studies.]" />
      <section className="wrap pb-20 sm:pb-28">
        <div className="grid gap-x-8 gap-y-16 md:grid-cols-2">
          {cases.map((c, i) => <Reveal key={c.slug} delay={(i % 2) * 0.1} className={i % 2 ? "md:mt-24" : ""}><CaseCard c={c} index={i} /></Reveal>)}
        </div>
      </section>
      <CtaBand title={["Your name", "could go here."]} />
    </>
  );
}
